<template>
    <div>        
        <div class="w-full flex justify-center">
            <div class="w-[460px]">
                <ElementsDateSearchPackLite
                    v-model:startDate="selectDate.startSearchDate" 
                    v-model:endDate="selectDate.endSearchDate" 
                    @searchEvent="searchSelectedDate" 
                />
            </div>
        </div>    
  
        <div class="mt-9">
            <table class="w-full min-w-[1084px] table-fixed border border-[#D6DDEB] rounded-lg bg-white">
                <colgroup v-if="isAboitiz">
                    <col style="width:3%" />
                    <col style="width:9%" />
                    <col style="width:15%" />
                    <col style="width:13%" />
                    <col style="width:15%" />
                    <col style="width:15%" />
                    <col style="width:6%" />
                    <col style="width:12%" />
                    <col style="width:12%" />
                </colgroup>
                <colgroup v-else>
                    <col style="width:3.4%" />
                    <col style="width:10.6%" />
                    <col style="width:14.2%" />
                    <col style="width:10.6%" />
                    <col style="width:18.2%" />
                    <col style="width:27.6%" />
                    <col style="width:15.4%" />
                </colgroup>
                <thead class="bg-white border-b border-[#D6DDEB] text-gray-600 font-inter-heading-19">
                    <tr>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">No</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Date</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Name</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Dept.& Tier</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Brand</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Treat Name</th>
                        <th scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Points</th>
                        <th v-if="isAboitiz" scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Cost Center</th><!-- Aboitiz 회사만을 위한 컬럼-->
                        <th v-if="isAboitiz" scope="col" class="py-4 text-gray-600 font-inter-heading-19 text-center">Business Unit</th><!-- Aboitiz 회사만을 위한 컬럼-->
                    </tr>
                </thead>

                <tbody class="">
                    <tr v-if="histListOverall.length === 0">
                            <td :colspan="isAboitiz ? 9 : 7" class="py-16 text-center text-content-basic-3 text-sm">
                            </td>
                        </tr>
                    <tr v-for="(hist, index) in histListOverall" v-bind:key="index" 
                        class="h-[4rem]" :class="[(index%2==0) ? 'bg-inherit' : 'bg-gray-100']">
                        <td class="py-2 pr-2 text-center text-black font-inter-heading-20 truncate">
                            {{ selectDate.offset + index + 1 }}
                        </td>
                        <td class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            <div> {{ dateFormatter(hist.transactionDate, 'MM/DD/YYYY') }}</div>
                            <div> {{ dateFormatter(hist.transactionDate, 'HH:mm') }}</div>
                        </td>
                        <td class="py-2 px-2 text-left text-base font-bold">
                            <div class="flex items-center gap-4 ">
                                <StatusCircle :status-code="hist.employeeStatus" class=""/>
                                <div class="font-semibold">
                                    <span class="block line-clamp-2 break-words">{{ $validateUtil.emptyValueToDash(hist.employeeName) }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            <div class="font-semibold line-clamp-1 truncate"> {{ hist.departmentName || "-" }}</div>
                            <div class="line-clamp-1 truncate"> {{ hist.jobTitleName || "-" }} </div>
                        </td>
                        <td class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            <span class="block line-clamp-2">{{ hist.brandName }}</span>
                        </td>
                        <td class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            <span class="block line-clamp-2">{{ hist.goodsName }}</span>
                        </td>
                        <td class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            {{ fitDecimalFormatWithComma(hist.totalAmountVolume,0) }}
                        </td>
                        <td v-if="isAboitiz" class="py-2 px-2 text-center text-black font-inter-heading-20 truncate">
                            <span class="block line-clamp-2">{{ $validateUtil.emptyValueToDash(hist.costCenterName) }}</span>
                        </td>
                        <td v-if="isAboitiz" class="py-2 pl-2 text-center text-black font-inter-heading-20 truncate">
                            <span class="block line-clamp-2">{{ $validateUtil.emptyValueToDash(hist.businessUnitName) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            
            <div class="w-full h-28 flex justify-center items-center">
                <ElementsPagination :unClickedBg="'bg-inherit hover:bg-gray-100'" v-model="currentPage" :totalContent="totalCount" :contentsPerPage="selectDate.limit" @clickPage="afterClickPage" />
            </div>
        </div>
    </div>    
</template>

<script>
import ElementsSelectSearchBar from '@/components/elements/ElementsSelectSearchBar';
import ElementsNotification from '@/components/elements/ElementsNotification.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import ElementsDateSearchPackLite from '@/components/elements/ElementsDateSearchPackLite.vue';
import ElementsPopupDownloadExcel from '@/components/elements/ElementsPopupDownloadExcel.vue';
import ElementsSearchBar from '@/components/elements/ElementsSearchBar.vue';
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import StatusCircle from '@/components/employee/status-circle/status-circle';
import { NumberFormatUtil } from '@/plugins/app-util';
import {getAboitizInfo} from "@/plugins/app-pre-init";
import moment from 'moment-timezone';

export default {
    components : {
        ElementsNotification,
        ElementsSelectSearchBar,
        DesignButton,
        DesignDropdownSelect,
        ElementsPopupDownloadExcel,
        ElementsSearchBar,
        StatusCircle,
        ElementsPagination,
        ElementsDateSearchPackLite,
    },
    mounted(){
        const self = this;
        self.initWeeklyRange();
        self.getPointUsageHistory();
    },      
    data(){
        return {
            selectDate: {
                limit: 10,
                offset: 0,
                startSearchDate: null,
                endSearchDate: null,
            },
            
            histListOverall : [],
            //paginantion
            totalCount : 0,
            currentPage : 0,

            // for aboitiz (cost center, business unit)
            aboitizSeq: getAboitizInfo().companySeq,
            companySeq: sessionStorage.getItem("companySeq"),
            isAboitiz: false,
        }
    },
    beforeMount() {
        this.isAboitiz = this.aboitizSeq == this.companySeq
    },
    methods : {
        initWeeklyRange() {
            const base = moment().local();
            const start = base.clone().startOf('isoWeek').startOf('day');
            const end = base.clone().startOf('isoWeek').add(6, 'days').endOf('day');

            this.selectDate.startSearchDate = start.toDate();
            this.selectDate.endSearchDate   = end.toDate();
        },
        toYYYYMMDD(date) {
            if (!(date instanceof Date)) return ''
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}${m}${d}`
        }, 
        fitDecimalFormatWithComma : NumberFormatUtil.fitDecimalFormatWithComma,
        dateFormatter(dateStr, outputFormat = 'MM/DD/YYYY') {
            if (!dateStr) return '';
            return moment(dateStr).format(outputFormat);
        },
        afterClickPage(offset){
            const self = this;
            self.getPointUsageHistory(offset);            
        },
        searchSelectedDate() {
            const self = this;
            self.getPointUsageHistory();
        },
        getPointUsageHistory( offset = 0 ){
            const self =  this;
            self.selectDate.offset= offset;
            
            const payload = {
                ...self.selectDate,
                startSearchDate: self.toYYYYMMDD(self.selectDate.startSearchDate),
                endSearchDate: self.toYYYYMMDD(self.selectDate.endSearchDate),
            };
            
            const json_query = JSON.stringify(payload);
            const url = self.$api("uri", "get-flexben-point-usage-list");
            self.$axios
            .get(url, { params: { json_query } })
            .then( res =>{
                self.histListOverall = res.data.data.list;
                self.totalCount = res.data.data.total;
            })
            .catch(err =>{
                console.error( "err : " , err);
            })
        }
    }
}
</script>
